var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('MainMenu'),_c('Header'),_c('MyAccountContent',{attrs:{"nextUrl":_vm.previousRoute}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }